export const buildNimrodGalleryUrl = image => {
  if (!image) return

  const { slug, parent } = image
  const { origin, pathname, search } = new URL(parent.url)
  return `${origin}${pathname}/${slug}${search}`
}

export const getGalleryFormattedUrl = url => {
  const urlObject = new URL(url)
  const params = urlObject.search
  const cleanUrl = params && urlObject.href.replace(params, '/')
  return { url: cleanUrl || url, params }
}
